/** Retour drill-down → fiche titre → réouverture du modal (Flux, Leaders, Stratégies). */

const PREFIX = "invelps.drillReturn.";

export function saveDrillReturnState(origin, payload) {
  if (typeof window === "undefined" || !origin) return;
  try {
    window.sessionStorage.setItem(
      `${PREFIX}${origin}`,
      JSON.stringify({ ...payload, savedAt: Date.now() })
    );
  } catch {
    /* ignore */
  }
}

export function loadDrillReturnState(origin) {
  if (typeof window === "undefined" || !origin) return null;
  try {
    const raw = window.sessionStorage.getItem(`${PREFIX}${origin}`);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearDrillReturnState(origin) {
  if (typeof window === "undefined" || !origin) return;
  try {
    window.sessionStorage.removeItem(`${PREFIX}${origin}`);
  } catch {
    /* ignore */
  }
}
